export const Z = {
  dropdown: 200,
  globalNav: 100,
  popover: 75,
  toasts: 150,
  footer: 1,
}
